const burger = document.querySelector(".burger");
const burgerMenu = document.querySelector(".burger-menu");
// const navLinks = nav.querySelectorAll('.nav__link')
const html = document.querySelector("html");

const closeNavMenu = () => {
  burger.classList.remove("is-active");
  burgerMenu.classList.remove("is-active");
  html.classList.remove("lock");
}

burger.addEventListener("click", () => {
  burgerMenu.classList.toggle("is-active");
  burger.classList.toggle("is-active");
  html.classList.toggle("lock");
});

// navLinks.forEach(navLink => {
//   navLink.addEventListener('click', () => {
//     closeNavMenu();
//   })
// })

// document.addEventListener("click", (e) => {
//   if (e.target === nav) {
//     closeNavMenu();
//   }
// });


document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    closeNavMenu();
  }
});

export default closeNavMenu;
